import { useLayout } from '../../state/layout.js';
import { useScene } from '../../state/scene.js';

/** Dock id of the Particle Editor tool panel. */
export const PARTICLE_EDITOR_PANEL = 'particles';

/** Shows the Particle Editor (selecting `entityId` first when given). */
export function openParticleEditor(entityId?: string): void {
  if (entityId && !useScene.getState().selection.includes(entityId)) useScene.getState().select([entityId]);
  useLayout.getState().show(PARTICLE_EDITOR_PANEL);
}

/** Window menu / shortcut: show the panel, or hide it when it is already on screen. */
export function toggleParticleEditor(visible: boolean): void {
  const layout = useLayout.getState();
  if (visible) layout.toggle(PARTICLE_EDITOR_PANEL);
  else layout.show(PARTICLE_EDITOR_PANEL);
}
